class FeaturedCollectionSlider extends HTMLElement {
  connectedCallback() {
    // swiperJs.js is deferred at the end of <body>, so it runs after this script
    if (window.Swiper) {
      this.initSlider();
      return;
    }

    document.addEventListener('load:swiper', () => this.initSlider(), { once: true });
  }

  disconnectedCallback() {
    if (this.slider) {
      this.slider.destroy(true, true);
      this.slider = null;
    }
  }

  initSlider() {
    const viewportElement = this.querySelector('[data-slider-viewport]');

    if (!viewportElement || !window.Swiper || this.slider) return;

    const { loopedSlides, loop } = this.dataset;

    this.slider = new window.Swiper(viewportElement, {
      loop: loop === 'true',
      loopedSlides: Number(loopedSlides),
      speed: 200,
      grabCursor: true,
      watchOverflow: true,
      slidesPerView: 'auto',
      touchRatio: 1,
      threshold: 10,
      spaceBetween: 15,
      navigation: {
        prevEl: this.querySelector('[data-slider-prev]'),
        nextEl: this.querySelector('[data-slider-next]'),
        disabledClass: 'featured-collection-slider__arrow--disabled',
        lockClass: 'featured-collection-slider__arrow--hidden',
      },
      breakpoints: {
        1025: {
          spaceBetween: 20,
        },
      },
    });
  }
}

if (!customElements.get('featured-collection-slider')) {
  customElements.define('featured-collection-slider', FeaturedCollectionSlider);
}
